// extracted by css-extract-rspack-plugin
export default {"cls1":"TranslationModal-cls1_KsY","cls2":"TranslationModal-cls2_3g3 TranslationModal-cls1_KsY","hide":"TranslationModal-hide___M"};